<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListCustomer()" isJump />
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" import export print custom :loading="loading">
      <template #buttons>
        <el-button type="success" size="mini" @click="itemAdd"> 新增客户 </el-button>
        <el-button type="danger" size="mini" @click="batchDelete">删除客户</el-button>
        <el-button type="primary" size="mini" @click="batchReplaceSalesMan">
          批量替换业务员
        </el-button>
        <el-button type="primary" size="mini" @click="batchBan">激活/禁用客户</el-button>
      </template>
      <template #tools>
        <el-button
          size="mini"
          title="模板下载"
          class="el-icon-notebook-2"
          circle
          plain
          @click="downloadModule"
        />
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :loading="loading"
      :height="this.$util.getViewHeight() - 187"
      :print-config="{}"
      :import-config="{
        remote: true,
        importMethod: this.importMethod,
        modes: ['insert'],
        type: ['xlsx'],
        types: ['xlsx']
      }"
      :scroll-y="{ enabled: false }"
      :data="tableDataMain"
      :columns="tableColumn"
      :mouse-config="{ selected: false }"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          @change="headerFilterChange"
        />
      </template>
      <template #header_daterange="{ column }">
        <c-table-header
          type="daterange"
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :value.sync="filterData.create_date"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_customer_name="{ row }">
        <el-link type="primary" @click="remarkDetail(row)">{{ row.customer_name }}</el-link>
      </template>
      <template #default_operate1="{ row }">
        <el-link type="success" @click="remarkAdd(row)">写跟进</el-link>
      </template>
      <template #default_operate2="{ row }">
        <el-link type="primary" @click="itemEdit(row.id)">编辑</el-link>
        <el-link v-if="isAdmin" type="success" @click="itemLog(row)"> 更新记录 </el-link>
        <el-link type="danger" @click="itemDelete(row)">删除</el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改客户 -->
    <b-popup-customer
      v-if="isShowPopupCustomer"
      :show.sync="isShowPopupCustomer"
      :id="activeId"
      @success="getListData"
    />

    <!-- 弹窗-导入 -->
    <PopupImport
      v-if="isShowPopupImport"
      :show.sync="isShowPopupImport"
      :isError="isError"
      :uuid="uuid"
      :list="importTableData"
      @success="getListData"
    />

    <!-- 弹窗-批量替换 -->
    <PopupBatchReplace
      v-if="isShowPopupBatchReplace"
      :show.sync="isShowPopupBatchReplace"
      :list="checkboxListData"
      @success="getListData"
    />

    <!-- 弹窗-写跟进 -->
    <PopupRemarkAdd
      v-if="isShowPopupRemarkAdd"
      :show.sync="isShowPopupRemarkAdd"
      :detail="activeDetail"
      @success="getListData"
    />

    <!-- 弹窗-跟进记录 -->
    <PopupRemarkDetail
      v-if="isShowPopupRemarkDetail"
      :show.sync="isShowPopupRemarkDetail"
      :detail="activeDetail"
      @success="getListData"
    />

    <!-- 弹窗-客户修改日志 -->
    <PopupUpdateLog
      v-if="isShowPopupUpdateLog"
      :show.sync="isShowPopupUpdateLog"
      :detail="activeDetail"
    />
  </div>
</template>

<script>
import PopupImport from './popup-import'
import PopupBatchReplace from './popup-batch-replace'
import PopupRemarkAdd from '../common/popup-remark-add'
import PopupRemarkDetail from '../common/popup-remark-detail'
import PopupUpdateLog from '../common/popup-update-log'

export default {
  components: {
    PopupImport,
    PopupBatchReplace,
    PopupRemarkAdd,
    PopupRemarkDetail,
    PopupUpdateLog
  },
  data() {
    return {
      loading: true,

      remvoeIds: [],
      banIds: [],

      filterData: {
        create_date: [this.$util.getDate().yearDay, this.$util.getDate().today]
      },
      sortData: { create_date: 'desc' },
      headerFilterUrl: '/admin/customers/searchHeard',
      tableColumn: [
        {
          type: 'checkbox',
          width: 40
        },
        {
          field: 'id',
          width: 80,
          title: '客户编号',
          slots: { header: 'header_input' }
        },
        {
          field: 'create_date',
          width: 180,
          title: '创建日期',
          slots: { header: 'header_daterange' }
        },
        {
          field: 'sales_man',
          title: '业务员',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          field: 'customer_name',
          title: '客户企业名称',
          slots: { header: 'header_input', default: 'default_customer_name' }
        },
        {
          field: 'linkman',
          title: '联系人',
          width: 80,
          slots: { header: 'header_input' }
        },
        {
          field: 'phone',
          title: '联系电话',
          width: 90,
          slots: { header: 'header_input' }
        },
        {
          field: 'gen_zong_count',
          title: '跟进次数',
          width: 60,
          slots: { header: 'header_input' }
        },
        {
          field: 'state',
          title: '使用状态',
          width: 60,
          slots: { header: 'header_input' }
        },
        {
          field: 'wei_xin',
          title: '联系人微信',
          slots: { header: 'header_input' }
        },
        {
          field: 'address',
          title: '客户地址',
          slots: { header: 'header_input' }
        },
        {
          field: 'alibaba',
          title: '旺旺号',
          width: 80,
          slots: { header: 'header_input' }
        },
        {
          field: 'lai_yuan',
          title: '客户来源',
          width: 80,
          slots: { header: 'header_input' }
        },
        {
          title: '跟进操作',
          width: 80,
          slots: { default: 'default_operate1' }
        },
        {
          title: '客户操作',
          width: 160,
          slots: { default: 'default_operate2' }
        }
      ],
      tableDataMain: [],
      pageOptions: {
        ...this.$constant.page
      },

      isShowPopupImport: false,
      isShowPopupBatchReplace: false,
      isShowPopupCustomer: false,
      isShowPopupRemarkAdd: false,
      isShowPopupRemarkDetail: false,
      isShowPopupUpdateLog: false,
      isError: '',
      activeDetail: null,
      activeId: null,
      uuid: '',
      importTableData: [],

      checkboxListData: []
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    }
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索数据列表
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取数据列表
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/customers/search',
        data: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          sortData: this.sortData,
          filterData: this.filterData
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableDataMain = res.data.page.list
            this.pageOptions.pageSize = res.data.page.pageSize
            this.pageOptions.total = res.data.page.totalRow
            this.pageOptions.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    itemAdd() {
      this.activeId = null
      this.isShowPopupCustomer = true
    },
    itemEdit(id) {
      this.activeId = id
      this.isShowPopupCustomer = true
    },
    itemLog(data) {
      this.activeDetail = data
      this.isShowPopupUpdateLog = true
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/customers/deleteVue',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.status === 200 && res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    },
    // 批量-激活/禁用
    batchBan() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      this.banIds = []
      for (let i = 0; i < selectRecords.length; i++) {
        this.banIds.push(selectRecords[i].id)
      }
      if (selectRecords.length > 0) {
        this.$confirm(`您确认要激活/禁用${this.banIds.length}个客户?`, '提示')
          .then(() => {
            this.$api({
              method: 'get',
              url: '/admin/customers/banBatchVue',
              params: {
                banIds: this.banIds
              }
            }).then((res) => {
              if (res.status === 200 && res.data.state === 'ok') {
                this.$message.success('批量删除成功')
                this.getListData()
              }
            })
          })
          .catch(() => {})
      } else {
        this.$message.error('请先选择')
      }
    },
    // 批量-删除
    batchDelete() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      this.remvoeIds = []
      for (let i = 0; i < selectRecords.length; i++) {
        this.remvoeIds.push(selectRecords[i].id)
      }
      if (selectRecords.length > 0) {
        this.$confirm(`您确认要删除${this.remvoeIds.length}条数据?`, '提示')
          .then(() => {
            this.$api({
              method: 'get',
              url: '/admin/customers/deleteBatchVue',
              params: {
                remvoeIds: this.remvoeIds
              }
            }).then((res) => {
              if (res.status === 200 && res.data.state === 'ok') {
                this.$message.success('批量删除成功')
                this.getListData()
              }
            })
          })
          .catch(() => {})
      } else {
        this.$message.error('请先选择')
      }
    },
    // 批量-替换业务员
    batchReplaceSalesMan() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      if (selectRecords.length > 0) {
        this.checkboxListData = selectRecords
        this.isShowPopupBatchReplace = true
      } else {
        this.$message.error('请先选择')
      }
    },
    // 模板下载
    downloadModule() {
      window.open('/template/Customers.xlsx', '_blank')
    },
    // 导入方法
    importMethod({ file }) {
      const formBody = new FormData()
      formBody.append('file', file)
      this.$api({
        method: 'post',
        url: '/admin/customers/importExcel',
        data: formBody
      })
        .then((res) => {
          if (res.status === 200 && res.data.state === 'ok') {
            this.isError = res.data.isError
            if (res.data.isError == true) {
              this.importTableData = res.data.customerListError
            } else {
              this.importTableData = res.data.customerList
            }

            this.uuid = res.data.uuid
            this.isShowPopupImport = true
          }
        })
        .catch(() => {})
    },
    // 记录-新增
    remarkAdd(data) {
      this.activeDetail = data
      this.isShowPopupRemarkAdd = true
    },
    // 记录-详情
    remarkDetail(data) {
      this.activeDetail = data
      this.isShowPopupRemarkDetail = true
    }
  },
  created() {
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.refTable.connect(this.$refs.refToolbar)
      this.getListData()
    })
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
